// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hufS4R {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: 24px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.K8cZug {
  font-family: var(--font-family-base);
  font-weight: 600;
  font-size: 14px;
  line-height: 1.8em;
  color: #1f1f1f;
  margin: 0;
  padding: 0;
}

.nRbfAK {
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 1;
}

.L20M2w {
  display: flex;
  flex-direction: row;
  align-self: stretch;
  gap: 24px;
  width: 100%;
}

.P6SUzT {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 400px;
}

.C265wS {
  font-family: var(--font-family-base);
  font-weight: 400;
  font-size: 14px;
  line-height: 1.8em;
  color: #1f1f1f;
  height: 21px;
  margin: 0;
  padding: 0;
}

.Xx4r4O {
  font-family: var(--font-family-base);
  font-weight: 600;
  font-size: 14px;
  line-height: 1.8em;
  color: #1f1f1f;
  margin: 0;
  padding: 0;
  word-break: break-all;
  display: flex;
  align-items: center;
  gap: 8px;
}

.kFgVsm {
  flex: 1;
}

.LWEKoz {
  font-family: var(--font-family-base);
  font-weight: 600;
  font-size: 20px;
  line-height: 1.42em;
  color: #1f1f1f;
  margin: 0;
  padding: 0;
}

.CmxS3K {
  width: 100%;
  height: 1px;
  background-color: #e6e6e6;
  margin: 0;
  padding: 0;
}

.i4fUtZ {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
  flex-shrink: 0;
  gap: var(--spacing-0-5);
}

.i4fUtZ:hover {
  background-color: var(--surface-neutral-pale, #f5f5f5);
}

.Bp7jGn {
  width: 16px;
  height: 16px;
  color: #d64000;
}

.swC8yM {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
  gap: var(--spacing-2, 16px);
  background-color: var(--surface-neutral-white);
  padding: 15px 0 0 0;
}

.CvlNoo {
  height: 40px;
  width: 100px;
  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);
  border-radius: var(--button-border-radius, 4px);
  background: var(--surface-neutral-white, #ffffff);
  border: 2px solid var(--brand-tr-orange, #d64000);
  color: var(--text-primary-medium, #1f1f1f);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold, 600);
  font-size: var(--font-size-md, 14px);
  cursor: pointer;
  transition: all 0.2s ease;
}

.CvlNoo:hover {
  background: var(--surface-neutral-pale, #f5f5f5);
}

.dMBXAB {
  height: 40px;
  min-width: 100px;
  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);
  border-radius: var(--button-border-radius, 4px);
  background: var(--brand-tr-orange, #d64000);
  border: 2px solid var(--brand-tr-orange, #d64000);
  color: var(--text-neutral-white, #ffffff);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold, 600);
  font-size: var(--font-size-md, 14px);
  cursor: pointer;
  transition: all 0.2s ease;
}

.dMBXAB:hover:not(:disabled) {
  background: var(--brand-tr-orange-dark, #b33600);
  border-color: var(--brand-tr-orange-dark, #b33600);
}

.dMBXAB:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  background: var(--disabled-subtle-surface, #f5f5f5);
  color: var(--text-neutral-strong, #666666);
  border: 2px solid var(--disabled-subtle-surface, #f5f5f5);
}

/* Responsividade para telas menores */
@media (max-width: 768px) {
  .L20M2w {
    flex-direction: column;
    gap: 16px;
  }

  .P6SUzT {
    width: 100%;
  }

  .hufS4R {
    padding: 16px;
    gap: 16px;
  }

  .nRbfAK {
    gap: 16px;
  }
}

.CzAxha {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  color: var(--brand-tr-orange);
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/PaymentBilletRevision/PaymentBilletRevision.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,UAAU;EACV,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,2BAA2B;EAC3B,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,uDAAuD;EACvD,+CAA+C;EAC/C,iDAAiD;EACjD,iDAAiD;EACjD,0CAA0C;EAC1C,oCAAoC;EACpC,6CAA6C;EAC7C,oCAAoC;EACpC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uDAAuD;EACvD,+CAA+C;EAC/C,2CAA2C;EAC3C,iDAAiD;EACjD,yCAAyC;EACzC,oCAAoC;EACpC,6CAA6C;EAC7C,oCAAoC;EACpC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;EAChD,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mDAAmD;EACnD,0CAA0C;EAC1C,yDAAyD;AAC3D;;AAEA,sCAAsC;AACtC;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,6BAA6B;AAC/B","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  gap: 24px;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.8em;\n  color: #1f1f1f;\n  margin: 0;\n  padding: 0;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  flex: 1;\n}\n\n.section {\n  display: flex;\n  flex-direction: row;\n  align-self: stretch;\n  gap: 24px;\n  width: 100%;\n}\n\n.fieldGroup {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 400px;\n}\n\n.fieldLabel {\n  font-family: var(--font-family-base);\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.8em;\n  color: #1f1f1f;\n  height: 21px;\n  margin: 0;\n  padding: 0;\n}\n\n.fieldValue {\n  font-family: var(--font-family-base);\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.8em;\n  color: #1f1f1f;\n  margin: 0;\n  padding: 0;\n  word-break: break-all;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.dateText {\n  flex: 1;\n}\n\n.amountValue {\n  font-family: var(--font-family-base);\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 1.42em;\n  color: #1f1f1f;\n  margin: 0;\n  padding: 0;\n}\n\n.divider {\n  width: 100%;\n  height: 1px;\n  background-color: #e6e6e6;\n  margin: 0;\n  padding: 0;\n}\n\n.calendarButton {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  transition: background-color 0.2s ease;\n  flex-shrink: 0;\n  gap: var(--spacing-0-5);\n}\n\n.calendarButton:hover {\n  background-color: var(--surface-neutral-pale, #f5f5f5);\n}\n\n.iconCalendar {\n  width: 16px;\n  height: 16px;\n  color: #d64000;\n}\n\n.footer {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  width: 100%;\n  gap: var(--spacing-2, 16px);\n  background-color: var(--surface-neutral-white);\n  padding: 15px 0 0 0;\n}\n\n.backButton {\n  height: 40px;\n  width: 100px;\n  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);\n  border-radius: var(--button-border-radius, 4px);\n  background: var(--surface-neutral-white, #ffffff);\n  border: 2px solid var(--brand-tr-orange, #d64000);\n  color: var(--text-primary-medium, #1f1f1f);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold, 600);\n  font-size: var(--font-size-md, 14px);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.backButton:hover {\n  background: var(--surface-neutral-pale, #f5f5f5);\n}\n\n.confirmButton {\n  height: 40px;\n  min-width: 100px;\n  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);\n  border-radius: var(--button-border-radius, 4px);\n  background: var(--brand-tr-orange, #d64000);\n  border: 2px solid var(--brand-tr-orange, #d64000);\n  color: var(--text-neutral-white, #ffffff);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold, 600);\n  font-size: var(--font-size-md, 14px);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.confirmButton:hover:not(:disabled) {\n  background: var(--brand-tr-orange-dark, #b33600);\n  border-color: var(--brand-tr-orange-dark, #b33600);\n}\n\n.confirmButton:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  background: var(--disabled-subtle-surface, #f5f5f5);\n  color: var(--text-neutral-strong, #666666);\n  border: 2px solid var(--disabled-subtle-surface, #f5f5f5);\n}\n\n/* Responsividade para telas menores */\n@media (max-width: 768px) {\n  .section {\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .fieldGroup {\n    width: 100%;\n  }\n\n  .container {\n    padding: 16px;\n    gap: 16px;\n  }\n\n  .content {\n    gap: 16px;\n  }\n}\n\n.mediumRegularOrangeText {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  color: var(--brand-tr-orange);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `hufS4R`,
	"title": `K8cZug`,
	"content": `nRbfAK`,
	"section": `L20M2w`,
	"fieldGroup": `P6SUzT`,
	"fieldLabel": `C265wS`,
	"fieldValue": `Xx4r4O`,
	"dateText": `kFgVsm`,
	"amountValue": `LWEKoz`,
	"divider": `CmxS3K`,
	"calendarButton": `i4fUtZ`,
	"iconCalendar": `Bp7jGn`,
	"footer": `swC8yM`,
	"backButton": `CvlNoo`,
	"confirmButton": `dMBXAB`,
	"mediumRegularOrangeText": `CzAxha`
};
module.exports = ___CSS_LOADER_EXPORT___;
